var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.is_open_vertical_radar,
          expression: "is_open_vertical_radar"
        }
      ],
      staticClass: "vertical-radar-profile",
      class: {
        "vertical-radar-profile--active": _vm.is_open_vertical_radar
      },
      attrs: { id: "vertical-radar-profile" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.toggle_vertical_radar(false)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "kxd-vertical-map-container",
          staticClass: "kxd-vertical-map-container",
          class: {
            "kxd-vertical-map-container--active": _vm.is_open_vertical_radar
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "vertical-header" },
            [
              _c("img", {
                staticClass: "vertical-dialog-title",
                attrs: {
                  src: "/static/images/tsmodal/CWA-modal-logo.png",
                  alt: "cwa logo"
                }
              }),
              _vm._v(" "),
              _vm.path_menu_options.length
                ? _c(
                    "v-icon",
                    {
                      attrs: { color: "#fff" },
                      on: {
                        click: function($event) {
                          _vm.is_open_path_menu = !_vm.is_open_path_menu
                        }
                      }
                    },
                    [_vm._v("\n                menu\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "modal-close",
                attrs: { src: "/static/images/tsmodal/close.png" },
                on: {
                  click: function($event) {
                    return _vm.toggle_vertical_radar(false)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "map-ctrl map-right-bottom-ctrl" },
            [
              _vm.colorbar
                ? _c("Colorbar", {
                    ref: "vertical-colorbar",
                    staticClass: "map-high-item vertical-colorbar",
                    attrs: { options: _vm.colorbar, draggable: true }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("section", { staticClass: "map-ctrl map-bottom-ctrl" }, [
            _c(
              "div",
              { staticClass: "map-high-item vertical-timebar" },
              [
                _vm.timebar.list.length > 0
                  ? _c("QpeTimeLine", {
                      attrs: {
                        props_play_index: _vm.timebar.default_index,
                        list: _vm.timebar.list,
                        duration: _vm.timebar.duration,
                        latest_complete_data_timestamp:
                          _vm.timebar.latest_complete_data_timestamp,
                        auto_update_btn_activate: false
                      },
                      on: {
                        "update:props_play_index": function($event) {
                          return _vm.$set(_vm.timebar, "default_index", $event)
                        },
                        "trigger-change-time": _vm.change
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.path_menu_options.length
            ? _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.is_open_path_menu,
                      expression: "is_open_path_menu"
                    }
                  ],
                  staticClass: "path-menu"
                },
                [
                  _c("div", { staticClass: "path-menu__block" }, [
                    _c("div", { staticClass: "path-menu__title" }, [
                      _c("span", [_vm._v("航路")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              _vm.path_selected = null
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        清除\n                    "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "path-menu__content" },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: { "hide-details": "" },
                            model: {
                              value: _vm.path_selected,
                              callback: function($$v) {
                                _vm.path_selected = $$v
                              },
                              expression: "path_selected"
                            }
                          },
                          _vm._l(_vm.path_menu_options, function(option) {
                            return _c("v-radio", {
                              key: option,
                              staticClass: "data_item",
                              attrs: {
                                label: option,
                                value: option,
                                ripple: false
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            ref: "kxd-vertical-map",
            staticClass: "kxd-vertical-map",
            attrs: { id: "kxd-vertical-map" }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }